import React, { useState, useEffect } from 'react'
import { Drawer } from "antd";
import TableRow from "./TableRow";
import NoDataFound from '../../../component/common/NoDataFound';
import AgentChatModal from './AgentChatModal';
// import "../../admin/report/chatReport/component/Report.css";

const ReportTable = (props) => {
    const [open, setOpen] = useState(props.accept);
    const [selectedUser, setSelectedUser] = useState(null);

    useEffect(()=>{
        setOpen(props.accept);
        setSelectedUser(props.selected_user)
    },[props.accept]);

    const onClose = () => {
        setOpen(false);
    }

    const onChatHandel = async(row) => {
        setOpen(true);
        setSelectedUser(row);
    }
    return (
        <>
        <div className="table-responsive">
            <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
                <thead>
                    <tr className="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
                        <th className="w-250px sorting">
                            Session
                        </th>
                        <th className="w-250px sorting">
                            Public IP
                        </th>
                        <th className="w-250px sorting">
                            User Details
                        </th>
                        <th className="w-250px sorting">
                            Product Enquiry
                        </th>
                        <th className="w-250px sorting">
                            Transfer
                        </th>
                        <th className="w-250px sorting">
                        </th>
                    </tr>
                </thead>
                <tbody className="text-gray-600 fw-semibold set-system-user-list">
                    {props.tableRow.map((row, index) => (
                        <TableRow row={row} key={index} onChatButtonClick={onChatHandel} />
                    ))}
                    {props.tableRow.length === 0 &&<tr>
                        <td colSpan="10" className="text-center">
                            <NoDataFound className="w-30" setHtml="No Data found" />
                        </td>
                    </tr>}
                </tbody>
            </table>
        </div>

        <Drawer onClose={onClose} open={open} width={1200}>
            <AgentChatModal liveUsers={props.liveUsers} selectedUser={selectedUser} agents={props.allAgents} />
        </Drawer>
        </>
    )
}

export default ReportTable;